import { MultiSelect, Select, Stack, Text } from '@mantine/core';
import type { IntakeAnswers } from '../types';
import type { IntakeAction } from '../types';
import { THERAPY_TYPES, LANGUAGE_OPTIONS as LANGUAGE_CODED } from '@unify/fhir-model/provider-profile-datasets';

const LANGUAGE_SELECT_OPTIONS = LANGUAGE_CODED.map((l) => ({ value: l.code, label: l.display }));

const APPROACH_OPTIONS = THERAPY_TYPES.map((t) => ({ value: t.code, label: t.display }));

const DEMOGRAPHIC_OPTIONS = [
  'Same gender',
  'Older provider',
  'Younger provider',
  'BIPOC provider',
  'LGBTQ+ affirming',
];

interface StepPreferencesProps {
  answers: IntakeAnswers;
  dispatch: React.Dispatch<IntakeAction>;
}

export function StepPreferences({ answers, dispatch }: StepPreferencesProps): JSX.Element {
  return (
    <Stack gap="lg">
      <div>
        <Text size="sm" fw={500} mb="xs">
          Approaches (optional)
        </Text>
        <MultiSelect
          placeholder="Search or select..."
          data={APPROACH_OPTIONS}
          value={answers.specialties}
          onChange={(value) => dispatch({ type: 'SET_SPECIALTIES', payload: value })}
          searchable
          clearable
        />
      </div>
      <div>
        <Text size="sm" fw={500} mb="xs">
          Provider preferences (optional)
        </Text>
        <MultiSelect
          placeholder="Select any that matter to you"
          data={DEMOGRAPHIC_OPTIONS}
          value={answers.demographicPrefs}
          onChange={(value) => dispatch({ type: 'SET_DEMOGRAPHIC_PREFS', payload: value })}
          clearable
        />
      </div>
      <div>
        <Text size="sm" fw={500} mb="xs">
          Language
        </Text>
        <Select
          placeholder="Select language"
          data={LANGUAGE_SELECT_OPTIONS}
          value={answers.language ?? 'en'}
          onChange={(value) => dispatch({ type: 'SET_LANGUAGE', payload: value ?? 'en' })}
          allowDeselect={false}
        />
      </div>
    </Stack>
  );
}
